import type { UseFormReturn } from 'react-hook-form';
import { ControlledInput } from 'smoothie';
import { z } from 'zod';

import { FormModuleContainer } from './FormModuleContainer';

export const groupSettingsFormSchema = z.object({
    groupSettings: z.object({
        name: z.string().min(1, { message: 'Set name is required' }),
        description: z.string().optional(),
        priority: z
            .string()
            .min(1)
            .refine(
                (priority) => !isNaN(parseInt(priority)),
                'Enter a valid number',
            ),
    }),
});

export type GroupSettingsFormSchema = z.infer<typeof groupSettingsFormSchema>;

interface GroupSettingsFormModuleProps<TContext> {
    formFunctions: UseFormReturn<GroupSettingsFormSchema, TContext>;
}

export const GroupSettingsFormModule = <TContext,>({
    formFunctions,
}: GroupSettingsFormModuleProps<TContext>) => {
    const {
        control,
        register,
        formState: { errors },
    } = formFunctions;

    return (
        <FormModuleContainer title="Set settings">
            <ControlledInput
                name="groupSettings.name"
                label="Set name"
                size="tiny"
                fontWeight="regular"
                control={control}
                register={register}
                errors={errors}
            />
            <ControlledInput
                name="groupSettings.priority"
                label="Set priority"
                size="tiny"
                fontWeight="regular"
                control={control}
                register={register}
                errors={errors}
            />
        </FormModuleContainer>
    );
};
